import React, { use, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api/api";
import BusinessSetUpModal from "../../components/BusinessSetUpModal/BusinessSetUpModal";

const SignUp = () => {
  const [signUpDetails, setSignUpDetails] = useState({firstName: "", lastName: "", email: "", phoneNumber: "", username: "", password: "", confirmPassword: ""});
  const [businessDetails, setBusinessDetails] = useState({address: "Melbourne VIC, Australia", location: {lat: null, lng: null}});
  const [formError, setFormError] = useState("");
  const [successMessage, setSuccessMessage] = useState("")
  const [businessSetUpModalOpen, setBusinessSetUpModalOpen] = useState(false);
  const [loading, setLoading] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValidated()) {
      setFormError("")
      setBusinessSetUpModalOpen(true);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (isBusinessValidated()) {
      try {
        setLoading(true)
        const response = await api.post('/auth/register', {userDetails: signUpDetails, businessDetails: businessDetails})
        setSuccessMessage(response.data.message)
        setSignUpDetails({firstName: "", lastName: "", email: "", phoneNumber: "", username: "", password: "", confirmPassword: ""})
        setBusinessSetUpModalOpen(false)
      } catch (error) {
        setFormError(error.response.data.errorMsg)
        console.log(error)
        setBusinessSetUpModalOpen(false)
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignUpDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleBusinessChange = (e) => {
    const { name, value } = e.target;
    setBusinessDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const isValidated = () => {
    if (!signUpDetails.firstName) {
      setFormError("First name is required!");
      return false;
    }

    if (!signUpDetails.lastName) {
      setFormError("Last name is required!");
      return false;
    }

    if (!signUpDetails.email) {
      setFormError("Email address is required!");
      return false;
    }

    if (!signUpDetails.username) {
      setFormError("Username is required!");
      return false;
    }

    if (!signUpDetails.password) {
      setFormError("Username is required!");
      return false;
    }

    if (!signUpDetails.confirmPassword) {
      setFormError("Username is required!");
      return false;
    }

    if (signUpDetails.password !== signUpDetails.confirmPassword) {
      setFormError("Confirm password does not match!");
      return false;
    }
    return true;
  };


  const isBusinessValidated = () => {
    if (!businessDetails.businessName) {
      setFormError("Business name is required!");
      return false;
    }
    if(!businessDetails.location.lat){
      setFormError("You also need to pin your business on the map!")
    }

    return true;
  };

  return (
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
          Creat a new account
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" method="POST" onSubmit={handleSubmit}>
          <div className="flex items-center justify-between gap-5">
            <div>
              <label
                htmlFor="firstName"
                className="block text-sm/6 font-medium text-gray-900"
              >
                First name
              </label>
              <div className="mt-2">
                <input
                  id="firstName"
                  name="firstName"
                  onChange={handleChange}
                  value={signUpDetails.firstName}
                  type="text"
                  autoComplete="given-name"
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="lastName"
                className="block text-sm/6 font-medium text-gray-900"
              >
                Last name
              </label>
              <div className="mt-2">
                <input
                  id="lastName"
                  name="lastName"
                  onChange={handleChange}
                  value={signUpDetails.lastName}
                  type="text"
                  autoComplete="family-name"
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-sm/6 font-medium text-gray-900"
            >
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                onChange={handleChange}
                value={signUpDetails.email}
                autoComplete="email"
                required
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="phoneNumber"
              className="block text-sm/6 font-medium text-gray-900"
            >
              Phone number
            </label>
            <div className="mt-2">
              <input
                id="phoneNumber"
                name="phoneNumber"
                type="text"
                onChange={handleChange}
                value={signUpDetails.phoneNumber}
                autoComplete="phoneNumber"
                required
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="username"
              className="block text-sm/6 font-medium text-gray-900"
            >
              Username
            </label>
            <div className="mt-2">
              <input
                id="username"
                name="username"
                type="text"
                onChange={handleChange}
                value={signUpDetails.username}
                autoComplete="username"
                required
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label
                htmlFor="password"
                className="block text-sm/6 font-medium text-gray-900"
              >
                Password
              </label>
            </div>
            <div className="mt-2">
              <input
                id="password"
                name="password"
                onChange={handleChange}
                value={signUpDetails.password}
                type="password"
                autoComplete="new-password"
                required
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label
                htmlFor="confirmPassword"
                className="block text-sm/6 font-medium text-gray-900"
              >
                Confirm password
              </label>
            </div>
            <div className="mt-2">
              <input
                id="confirmPassword"
                name="confirmPassword"
                onChange={handleChange}
                value={signUpDetails.confirmPassword}
                type="password"
                autoComplete="new-password"
                required
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
              />
            </div>
          </div>

          {formError && !businessSetUpModalOpen && (
            <p id="email-error" className="mt-2 text-sm text-red-600">
              {formError}
            </p>
          )}

          {successMessage && !businessSetUpModalOpen && (
            <p id="email-error" className="mt-2 text-sm text-green-600">
              {successMessage} <Link to={"/sign-in"} className="font-medium text-green-700">Sign in now</Link>
            </p>
          )}

          <div>
            <button
              
              type="submit"
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Next
            </button>
          </div>
        </form>

        <p className="mt-10 text-center text-sm/6 text-gray-500">
          Already a member?
          <Link
            to="/sign-in"
            className="font-semibold text-indigo-600 hover:text-indigo-500"
          >
            {" "}
            Sign in now
          </Link>
        </p>
      </div>

      <BusinessSetUpModal
        businessSetUpModalOpen={businessSetUpModalOpen}
        setBusinessSetUpModalOpen={setBusinessSetUpModalOpen}
        handleBusinessChange={handleBusinessChange}
        handleRegister={handleRegister}
        formError={formError}
        setBusinessDetails={setBusinessDetails}
        loading={loading}
      />
    </div>
  );
};

export default SignUp;
